import { render, staticRenderFns } from "./CountryCard.vue?vue&type=template&id=97a1af4c&scoped=true&"
import script from "./CountryCard.vue?vue&type=script&lang=js&"
export * from "./CountryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1af4c",
  null
  
)

export default component.exports